import { render } from "./VendorProfile.vue?vue&type=template&id=7c6a5d3b&scoped=true"
import script from "./VendorProfile.vue?vue&type=script&lang=js"
export * from "./VendorProfile.vue?vue&type=script&lang=js"

import "./VendorProfile.vue?vue&type=style&index=0&id=7c6a5d3b&scoped=true&lang=css"
import "@/assets/css/dashStyle.css?vue&type=style&index=1&id=7c6a5d3b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6a5d3b"]])

export default __exports__